import widget from './widget';

/**
 * For reference for configurable options on this component refer to
 * @sky-uk/ita-sky-common-components in this point
 * https://github.com/sky-uk/ita-sky-common-components/blob/main/packages/sky-social-share/src/components/SocialShare/SocialShare.tsx
 */
export default {
  ...widget,
};
